<template>
  <div
    v-if="Object.keys($store.getters.bookings).length"
    :key="$store.getters.bookingCalendarHash"
  >
    <transition name="flixFadeIn">
      <div :key="date + $store.getters.calendarDate.getTime()">
        <calendarView
          v-if="!date"
          :callback="
            (settings) => {
              setDate(settings)
            }
          "
        />
        <detailView
          v-if="date"
          :date="$store.getters.calendarDate"
          :callback="
            (settings) => {
              setDate(settings)
            }
          "
        />
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  components: {
    calendarView: function () {
      return import('@/components/bookingCalendar/calendar')
    },
    detailView: function () {
      return import('@/components/bookingCalendar/detailView')
    }
  },
  data() {
    return {
      date: this.getDate(),
      variables: {}
    }
  },
  mounted() {
    this.variables = this.$getUserVariables()
    this.createDate()
  },
  methods: {
    createDate() {
      if (
        typeof this.$route.params.date !== 'string' ||
        !this.$route.params.date
      ) {
        return false
      }
      var date = this.$createDate(this.$route.params.date + ' 0:0')
      this.$store.commit('setCalendarDate', date)
    },
    getLink() {
      var link = { name: 'dashboard', params: { id: false } }
      if (this.variables.state === 'share') {
        var id = this.$store.getters.getShareNav
        link = {
          name: 'sharesCalendar',
          params: { ressource: id[0], calendar: id[1] }
        }
      }
      return link
    },
    getDate() {
      if (
        typeof this.$route.params === 'undefined' ||
        typeof this.$route.params.time === 'undefined'
      ) {
        return false
      }

      var date = new Date()
      date.setTime(this.$route.params.time)
      return {
        ID: this.$route.params.id,
        date: date
      }
    },
    setDate(settings) {
      this.date = settings

      var name = 'specificBookingCalendar'
      if (this.variables.state === 'share') {
        name = 'sharesDateEntriesBookingCalendar'
      }

      if (!settings) {
        this.$router.push({
          name: name
        })
        return false
      }

      this.$router.push({
        name: name,
        params: {
          id: settings.ID,
          time: settings.date.getTime()
        }
      })
    }
  }
}
</script>
